<template>
  <div class="w-full mx-auto sm:bg-white u-center sm:shadow-lg mb-4 sm:mb-9">
    <div class="flex flex-col max-w-[1100px] w-full">
      <div v-if="!isMobile" class="flex justify-between items-center h-[94px]">
        <h1 class="text-xl font-semibold text-primary-100">{{ game.name }}</h1>
        <div class="categories flex flex-row justify-center space-x-2 text-center text-[#A5A5A5] font-bold text-xs">
          <div v-for="c in game.categories" :key="c" class="flex border border-[#E6E6E6] rounded px-2 u-center h-[22px]">
            {{ c.toUpperCase() }}
          </div>
        </div>
      </div>
      <div v-else class="u-center flex flex-col space-y-2 text-center text-[#A5A5A5] font-bold text-xs h-[92px]">
        <div class="flex flex-row flex-wrap mx-auto space-x-1 space-y-1 u-center">
          <span v-for="c in game.categories" :key="c" class="border border-[#E6E6E6] rounded px-2 u-center h-[22px]">
            {{ c.toUpperCase() }}
          </span>
        </div>
        <h1 class="text-xl font-semibold text-primary-100 u-center">{{ game.name }}</h1>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, useRoute } from '@nuxtjs/composition-api';
import gameData from '../gameData';
import { useDevice } from '~/composables/useDevice';

export default defineComponent({
  setup(props) {
    const route = useRoute();
    const { isMobile } = useDevice();
    const slug = route.value.params.slug;
    const game = gameData.filter((g) => {
      return g.slug === slug;
    })[0];
    return { isMobile, game };
  },
});
</script>
